The status of the question.

Currently, two codes are defined:

- `Active` indicates that a question is active and can be used as input for the `createApplicationQuestionnaire` mutation.
- `Retired` indicates that a question has been retired and cannot be used as input for the `createApplicationQuestionnaire` mutation.
